// extracted by mini-css-extract-plugin
export default {"project_hero":"ProjectHero_project_hero__UvE-Y","hero_header":"ProjectHero_hero_header__yZPxN"};